import React, { useState, useEffect } from 'react';
import Joystick from './Joystick';

const LakePhoto = () => {
    const [charX, setCharX] = useState(50);
    const [gameWon, setGameWon] = useState(false);
    const [showCamera, setShowCamera] = useState(false);
    const [flash, setFlash] = useState(false);

    // Game constants
    const GAME_WIDTH = 400;
    const GAME_HEIGHT = 600;
    const CHAR_SPEED = 5;
    const LAKE_ZONE_START = 250; // Where the lake view starts

    // Handle movement
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (gameWon) return;

            if (e.key === 'ArrowRight') {
                setCharX(prev => Math.min(prev + CHAR_SPEED, GAME_WIDTH - 40));
            } else if (e.key === 'ArrowLeft') {
                setCharX(prev => Math.max(prev - CHAR_SPEED, 0));
            } else if (e.code === 'Space' && showCamera) {
                takePhoto();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [gameWon, showCamera]);

    // Check position for camera prompt
    useEffect(() => {
        if (charX > LAKE_ZONE_START && !gameWon) {
            setShowCamera(true);
        } else {
            setShowCamera(false);
        }
    }, [charX, gameWon]);

    const takePhoto = () => {
        setFlash(true);
        setTimeout(() => {
            setFlash(false);
            setGameWon(true);
        }, 200);
    };

    const resetGame = () => {
        setCharX(50);
        setGameWon(false);
        setShowCamera(false);
        setFlash(false);
    };

    // Handle joystick movement
    const handleJoystickMove = (data) => {
        if (gameWon) return;

        // Use x component for movement (range -1 to 1)
        if (Math.abs(data.x) > 0.1) {
            setCharX(prev => {
                const newX = prev + (data.x * CHAR_SPEED);
                return Math.max(0, Math.min(newX, GAME_WIDTH - 40));
            });
        }
    };

    return (
        <div className="lake-game-container" style={{ width: GAME_WIDTH, height: GAME_HEIGHT }}>
            {/* Night Sky Background */}
            <div className="lake-sky">
                <div className="moon"></div>
                <div className="stars">
                    {[...Array(20)].map((_, i) => (
                        <div
                            key={i}
                            className="star"
                            style={{
                                top: `${Math.random() * 50}%`,
                                left: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 2}s`
                            }}
                        />
                    ))}
                </div>
            </div>

            {/* Lake & Terrain */}
            <div className="lake-terrain">
                <div className="mountains"></div>
                <div className="lake-water">
                    <div className="reflection"></div>
                    {/* Moon Reflection - only visible when near lake */}
                    <div
                        className="moon-reflection"
                        style={{
                            opacity: Math.max(0, (charX - LAKE_ZONE_START) / 100)
                        }}
                    ></div>
                </div>
                <div className="ground"></div>
            </div>

            {/* Character */}
            <div
                className="pixel-char"
                style={{
                    left: charX,
                    bottom: '120px' // Position on ground
                }}
            >
                <div className="char-body"></div>
                <div className="char-head"></div>
                <div className="char-legs"></div>
            </div>

            {/* UI Overlays */}
            {showCamera && !gameWon && (
                <>
                    <div className="camera-overlay">
                        <div className="viewfinder"></div>
                        <p className="camera-prompt">PRESS SPACE OR CLICK SHUTTER</p>
                    </div>
                    <button className="shutter-button" onClick={takePhoto} aria-label="Take Photo"></button>
                </>
            )}

            {flash && <div className="camera-flash"></div>}

            {gameWon && (
                <div className="victory-screen">
                    <h2>BEAUTIFUL SHOT!</h2>
                    <div className="photo-result">
                        <div className="photo-content">
                            <div className="moon-sm"></div>
                            <div className="lake-sm"></div>
                        </div>
                    </div>
                    <button className="restart-btn" onClick={resetGame}>PLAY AGAIN</button>
                </div>
            )}

            <div className="game-controls-hint">
                Use Arrow Keys or Joystick to Move
            </div>

            <div className="joystick-wrapper">
                <Joystick onMove={handleJoystickMove} />
            </div>
        </div>
    );
};

export default LakePhoto;
